import { render, staticRenderFns } from "./ReactionsList.vue?vue&type=template&id=4c5bf56f&scoped=true"
import script from "./ReactionsList.vue?vue&type=script&lang=js"
export * from "./ReactionsList.vue?vue&type=script&lang=js"
import style0 from "./ReactionsList.vue?vue&type=style&index=0&id=4c5bf56f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5bf56f",
  null
  
)

export default component.exports